export const get = (path: string, value?: Record<string, any>, defaultValue?: any): any => {
  return path.split('.').reduce((acc, v) => {
    try {
      acc = acc?.[v];
    } catch (e) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return defaultValue;
    }
    return acc;
  }, value);
};

export const scrollToElement = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView();
  }
};
